export default "__VITE_ASSET__BiUkpuoJ__"